
import httpRequest from './../infrastructure/httphelper'
import sharedGlobals from '../sharedglobals';
class menuServices {
    constructor() {}
    

    getUserMenu() {
        alert(sharedGlobals);
 
        return httpRequest({
            //refactor code 

        }).then(function(resp){
           //
        });
    }
}  
let instance = new menuServices();
export default instance;